// loading.service.ts
import { Injectable, signal, computed } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  // Create a private signal to track the number of pending requests
  private requestCount = signal<number>(0);

  // Create a computed signal that determines if loading should be shown
  public loading = computed(() => this.requestCount() > 0);

  constructor() {}

  // Show the loader
  show(): void {
    this.requestCount.update((count) => count + 1);
  }

  // Hide the loader
  hide(): void {
    this.requestCount.update((count) => {
      const newCount = count - 1;
      return newCount < 0 ? 0 : newCount;
    });
  }
}
